// Moduł Spotkania (web): strony i komponenty dla profilu klienta / projektu i kompozycji (CONVENTIONS §10).
// Import rejestruje zakładkę „Spotkania” w profilu klienta (slot `setClientTab('meetings', …)`, jak moduł Oferty;
// zastępuje zaślepkę „Pojawi się w kolejnej wersji” z kompozycji Fali 1, bo routes.tsx importuje moduł po niej).
import { setClientTab } from '../clients/slots';
import { ClientMeetingsTab } from './components/ClientMeetingsTab';

export { ClientMeetingsTab } from './components/ClientMeetingsTab';
export { MeetingAiSection } from './components/MeetingAiSection';
export { MeetingRow } from './components/MeetingRow';
export { MeetingRows } from './components/MeetingRows';
export {
  EditMeetingDialog,
  NewMeetingButton,
  NewMeetingDialog,
  type NewMeetingDialogProps,
} from './components/NewMeetingDialog';
export { ProposalsBlock } from './components/ProposalsBlock';
export { readTranscriptFile, TranscriptField } from './components/TranscriptField';
export { TranscriptPanel } from './components/TranscriptPanel';
export * from './meeting-format';
export { MeetingDetailPage } from './pages/MeetingDetailPage';
export { MeetingsPage } from './pages/MeetingsPage';

setClientTab('meetings', ClientMeetingsTab);
